export default __webpack_public_path__ + "static/logo-tripadvisor2-203735fe15ac603f02649ada84d06377.png";